export default "__VITE_ASSET__BXDjtJv8__"